/**
 * Playback session id shared by all reporting on a page load.
 *
 * CMCD's `sid` must survive hls.js instance teardowns (pre-stream trailer
 * reload, error-recovery reloads, returning from cast), so it is minted
 * once per page load here instead of relying on the per-instance
 * `hls.sessionId` default — otherwise one viewing session fragments into
 * several sids in the analytics pipeline.
 */
let sessionId: string | null = null;

export function getPlaybackSessionId(): string {
  if (!sessionId) {
    sessionId = globalThis.crypto?.randomUUID?.() ?? generateFallbackId();
  }
  return sessionId;
}

/** RFC 4122-shaped fallback for environments without crypto.randomUUID. */
function generateFallbackId(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
